import { useContext, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../store/auth-context';
import { getTeacherRegistrationStatus } from '../api/auth-api';
import { registrationPage } from '../store/fixed-routing';
import { debugError } from '../utils/debug';

/** Nauczyciel bez profilu na bieżącej edycji → uzupełnienie rejestracji. */
export function useTeacherRegistrationGuard(): void {
	const { isTeacher, token } = useContext(AuthContext);
	const navigate = useNavigate();
	const checkedRef = useRef(false);

	useEffect(() => {
		if (!isTeacher || !token || checkedRef.current) {
			return;
		}
		checkedRef.current = true;
		getTeacherRegistrationStatus(token)
			.then((status) => {
				if (!status?.hasProfileOnLatest) {
					navigate(`${registrationPage}?resume=teacher`, { replace: true });
				}
			})
			.catch((error) => debugError('useTeacherRegistrationGuard failed', error));
	}, [isTeacher, token, navigate]);
}
